import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How quickly can you respond to an emergency?",
      answer: "For emergency calls, our average response time is 30-45 minutes. We prioritize emergency situations and dispatch the nearest available technician immediately. Call 082 793 5785 for immediate assistance."
    },
    {
      question: "Do you charge for quotes or estimates?",
      answer: "We provide free quotes for most standard services. For complex commercial projects, we may conduct a site visit to provide an accurate estimate. Emergency call-outs include a standard call-out fee which is applied to the final invoice."
    },
    {
      question: "What areas do you service?",
      answer: "We service the entire greater region including CBD, Northern, Southern, Eastern, and Western suburbs. Response times vary by location, with central areas receiving faster service. We also handle selected surrounding areas."
    },
    {
      question: "Are you licensed?",
      answer: "Yes, we are fully licensed. All our technicians hold relevant trade certifications and we follow safe working practices on every job."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept cash, EFT, credit cards, and debit cards. For commercial clients, we offer account facilities with approved credit terms. Payment is typically due upon completion of work."
    },
    {
      question: "Do you offer guarantees on your work?",
      answer: "Absolutely. All our work comes with warranties on parts and labor according to industry standards. If you're not satisfied, we'll make it right."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-card rounded-lg p-6 md:p-8 shadow-sm border border-border">
      <div className="mb-6">
        <h2 className="font-headline font-bold text-xl md:text-2xl lg:text-3xl mb-2">
          Frequently Asked Questions
        </h2>
        <p className="font-body text-sm md:text-base text-muted-foreground">
          Quick answers to common questions about our services
        </p>
      </div>
      <div className="space-y-3 md:space-y-4">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="border border-border rounded-lg overflow-hidden transition-all duration-300"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-4 md:p-5 bg-muted hover:bg-muted/80 transition-colors text-left"
            >
              <span className="font-headline font-semibold text-sm md:text-base lg:text-lg pr-4">
                {faq?.question}
              </span>
              <Icon
                name={openIndex === index ? "ChevronUp" : "ChevronDown"}
                size={20}
                className="flex-shrink-0 text-primary"
              />
            </button>

            <div
              className={`transition-all duration-300 overflow-hidden ${
                openIndex === index ? 'max-h-96' : 'max-h-0'
              }`}
            >
              <div className="p-4 md:p-5 bg-background">
                <p className="font-body text-sm md:text-base text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-start gap-3 bg-primary/10 rounded-lg p-4">
          <Icon name="HelpCircle" size={20} className="flex-shrink-0 text-primary mt-1" />
          <div className="flex-1 min-w-0">
            <h3 className="font-headline font-semibold text-base md:text-lg mb-1">
              Still have questions?
            </h3>
            <p className="font-body text-sm md:text-base text-muted-foreground mb-3">
              Our team is here to help. Call us at <span className="font-accent font-semibold text-accent">082 793 5785</span> or request a callback.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;